import React from 'react';
import { connect } from 'react-redux';

import BarChartTrend from 'components/charts/barChartTrend';
import PercentChangeBox from 'components/analytics/percentChangeBox';
import { Card, CardBody, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { IconInfoCircle } from '@tabler/icons-react';
import {
  getTotalActiveCoursesDataLabels,
  getTotalActiveCoursesDataValues,
  getCurrentTotalActiveCoursesTotalCount,
  getCurrentTotalActiveCoursesPercentageChange
} from 'selectors';

const renderTooltip = (props) => (
  <Tooltip id="active-courses" {...props}>
    Number of courses that are currently running.
  </Tooltip>
);

const ActiveCourses = (props) => {
  const { data_labels, data_values, percent_change, total_count } = props;

  return (
    <Card className="stats-box">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <Card.Title as="h3">{total_count}</Card.Title>
          <PercentChangeBox percent_change={percent_change} />
        </div>
        <Card.Text>
          Active Courses
          <OverlayTrigger placement="bottom" overlay={renderTooltip}>
            <span id="active-courses" className="ms-2">
              <IconInfoCircle stroke={1.5} />
            </span>
          </OverlayTrigger>
        </Card.Text>
        <BarChartTrend title="Courses Count" labels={data_labels} values={data_values} />
      </CardBody>
    </Card>
  );
};

function mapStateToProps(state) {
  const data_labels = getTotalActiveCoursesDataLabels(state);
  const data_values = getTotalActiveCoursesDataValues(state);
  const percent_change = getCurrentTotalActiveCoursesPercentageChange(state);
  const total_count = getCurrentTotalActiveCoursesTotalCount(state);

  return {
    data_labels,
    data_values,
    percent_change,
    total_count
  };
}

export default connect(mapStateToProps)(ActiveCourses);
